/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */
import type { ModalCommand } from '../types/modal.types';

export class ActiveModal {
  public execute(command?: ModalCommand): void {}
  public dismiss(reason?: any): void {}
}
